const environment = import.meta.env.VITE_UEFA_ENV ?? 'prod';
const envPrefix = environment !== 'prod' ? `${environment.toLowerCase()}.` : '';
export const UEFA_BASE_URL = `https://www.${envPrefix}uefa.com`;
